module.exports = __webpack_public_path__ + "static/img/1020_big.bd8cbdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1020_big.png
// module id = BAfk
// module chunks = 1